// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/standard-words-phrases.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/standard-words-phrases/standard-words-phrases.js';

mount([g0]);
